import { Fragment, useEffect, useState } from 'react';
import {
  ApplicationData,
  HouseholdIncome,
  IApplicationPreviewComments,
  userProfileRegisterApplicantI,
  WithIncomeChildI,
  WithIncomeFamilyI,
  WithoutIncomeChildI,
  WithoutIncomeFamilyI
} from '../../../../types/interface';
import { useAppDispatch } from '../../../redux/HooksRedux';
import * as applicationPreviewAction from '../../../redux/applicationPreview/applicationPreviewAction';
import {
  ApplicationStatusEnums,
  APPROVED,
  EDUCATION,
  FEEDBACK,
  HEALTH,
  PENDING,
  REJECTED,
  WITH_INCOME,
  WITHOUT_INCOME
} from 'utils/enums/misc';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { APPLICATION } from 'constant/RoutesUrls';
import {
  errorNotification,
  successNotification
} from 'base/notifications/Notifications';
import { t } from 'i18next';
import { Card } from 'react-bootstrap';
import ConditionalRender from 'base/ConditionalRender/ConditionalRender';
import { StandardLoader } from 'base/Loader/Loader';
import { StandardButton } from 'base/StandardButton/StandardButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { HealthApplication } from './applications/HealthApplication';
import { EducationApplication } from './applications/EducationApplication';
import { WithIncome } from './basicData/WithIncome';
import { RegisterApplicant } from './registerApplicant/RegisterApplicant';
import DeleteModel from 'base/DeleteModal/DeleteModal';
import { ValidationEnum } from 'utils/enums/validationEnums';
import {
  capitalizeFirstLetter,
  convertToCurrency,
  parseIntoNumber
} from 'utils/helpers';
import { HealthApplicationForm } from './applications/HealthApplicationForm';
import {
  calculationDataI,
  WithIncomeCalculator
} from 'pages/SubsidyCalculation/WithIncomeCalculator/WithIncomeCalculator';
import { WithoutIncomeSubsidyCalculation } from 'pages/SubsidyCalculation/WithoutIncome/WithoutIncomeSubsicidyCalculation';
import { WithIncomeSubsidyCalculation } from 'pages/SubsidyCalculation/WithIncome/WithIncomeSubsidyCalculation';
import { downApplicationPdf } from '../../../redux/common/commonAction';
import { WithoutIncome } from './basicData/WithoutIncome';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/rootReducer';
import ApplicationComments from 'components/base/ApplicationComments';

export const ApplicationPreview = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { userProfile } = useSelector((State: RootState) => State.userProfile);

  const [showRejectPopup, setShowRejectPopup] = useState(false);
  const [reviewForReject, setReviewForReject] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [applicationData, setApplicationData] = useState<ApplicationData>();
  const [userProfileData, setUserProfileData] =
    useState<userProfileRegisterApplicantI>();
  const [basicDataFamily, setBasicDataFamily] = useState<
    WithoutIncomeFamilyI[] | WithIncomeFamilyI[]
  >([]);
  const [basicDataChildren, setBasicDataChildren] = useState<
    WithIncomeChildI[] | WithoutIncomeChildI[]
  >([]);
  const [showError, setShowError] = useState(false);
  const [showApprovePopup, setShowApprovePopup] = useState(false);
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [applicationStatus, setApplicationStatus] =
    useState<ApplicationStatusEnums>(ApplicationStatusEnums.PENDING);

  const [searchParams, setSearchParams] = useSearchParams();
  const applicationId = searchParams.get('application_id');
  const applicationType = searchParams.get('application_type');
  const basicData = searchParams.get('basic_data');
  const [applicationSubmittedDate, setApplicationSubmittedDate] = useState('');
  const [submittedOn, setSubmittedOn] = useState('');
  const [showButtons, setShowButtons] = useState<{
    responsibility: boolean;
    changeStatus: boolean;
  }>({
    responsibility: true,
    changeStatus: false
  });
  // const [comments, setComments] = useState<IApplicationPreviewComments[]>([]);

  const [isPdfDownloading, setIsPdfDownloading] = useState(false);

  const approveApplication = async () => {
    try {
      const response = await dispatch(
        applicationPreviewAction.changeStatusOfApplication(
          {
            application_status: APPROVED,
            comments: ''
          },
          applicationId!
        )
      );
      if (response.status === 200) {
        navigate(APPLICATION);
        successNotification(t('overview.notification.approved'));
        setShowApprovePopup(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getRegistrationApplicant = async () => {
    setIsLoading(true);
    if (!applicationId) {
      return;
    }
    setIsLoading(true);
    try {
      const response = await dispatch(
        applicationPreviewAction.getOverviewData(applicationId)
      );
      setApplicationSubmittedDate(response?.data?.data?.submitted_on);
      setApplicationStatus(response.data?.data?.application_status);
      setUserProfileData(response.data?.data?.application_user_info);
      setBasicDataFamily(response.data?.data?.basic_data_family);
      setBasicDataChildren(response.data?.data?.basic_data_children);
      setApplicationData(response.data?.data?.application_data);
      setSubmittedOn(response?.data?.data?.submitted_on);
      // setComments(response?.data?.data?.comments);
      // if (
      //   response?.data?.data?.user_current_level.includes(
      //     response?.data?.data?.currentLevel
      //   )
      // ) {
      //   if (response?.data?.data?.show_buttons) {
      //     setShowButtons({
      //       responsibility: false,
      //       changeStatus: true
      //     });
      //   } else {
      //     setShowButtons({
      //       responsibility: true,
      //       changeStatus: false
      //     });
      //   }
      // } else {
      //   setShowButtons({ changeStatus: false, responsibility: false });
      // }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getRegistrationApplicant();
  }, []);

  const rejectApplication = async () => {
    if (!reviewForReject) {
      return setShowError(true);
    }
    try {
      const response = await dispatch(
        applicationPreviewAction.changeStatusOfApplication(
          {
            application_status: REJECTED,
            comments: reviewForReject
          },
          applicationId!
        )
      );
      if (response.status === 200) {
        navigate(APPLICATION);
        successNotification(t('overview.notification.rejected'));
        setReviewForReject('');
        setShowRejectPopup(false);
      }
    } catch (error) {
      console.log(error);
      setShowRejectPopup(false);
    }
  };

  const feedbackApplication = async () => {
    if (!reviewForReject) {
      return setShowError(true);
    }
    try {
      const response = await dispatch(
        applicationPreviewAction.changeStatusOfApplication(
          {
            application_status: FEEDBACK,
            comments: reviewForReject
          },
          applicationId!
        )
      );
      if (response.status === 200) {
        navigate(APPLICATION);
        successNotification(t('overview.notification.rejected'));
        setReviewForReject('');
        setShowFeedbackPopup(false);
      }
    } catch (error) {
      console.log(error);
      setShowFeedbackPopup(false);
    }
  };

  const renderApproveApplicationModal = () => {
    if (showApprovePopup) {
      return (
        <DeleteModel
          onCancel={() => {
            setShowApprovePopup(false);
          }}
          onConfirm={approveApplication}
          title={t('overview.model.text_2')}
        />
      );
    }
  };

  const renderRejectApplicationModal = () => {
    if (showRejectPopup) {
      return (
        <DeleteModel
          onCancel={() => setShowRejectPopup(false)}
          onConfirm={rejectApplication}
          title={t('reject_modal.title')}
          showInput={true}
          inputProps={{
            className: 'mt-2',
            label: '',
            onChange: (e: string | number) => {
              setReviewForReject(e as string);
            },
            placeholder: t('reject_modal.label'),
            showError: showError,
            validations: [
              {
                type: ValidationEnum.REQUIRED,
                message: 'please enter a reason',
                key: 'validation.review.reject_reason'
              }
            ],
            type: '',
            value: reviewForReject,
            as: 'textarea',
            rows: 4
          }}
        />
      );
    }
  };

  const renderFeedbackApplicationModal = () => {
    if (showFeedbackPopup) {
      return (
        <DeleteModel
          onCancel={() => setShowFeedbackPopup(false)}
          onConfirm={feedbackApplication}
          title={t('feedback_modal.title')}
          showInput={true}
          inputProps={{
            className: 'mt-2',
            label: '',
            onChange: (e: string | number) => {
              setReviewForReject(e as string);
            },
            placeholder: t('feedback_modal.label'),
            showError: showError,
            validations: [
              {
                type: ValidationEnum.REQUIRED,
                message: 'please enter a reason',
                key: 'validation.review.reject_reason'
              }
            ],
            type: '',
            value: reviewForReject,
            as: 'textarea',
            rows: 4
          }}
        />
      );
    }
  };

  const calculateTotalIncome = () => {
    console.log('render');
    let totalIncome = 0;
    let totalHouseholdIncomePerAdult = 0;
    const incomeData: calculationDataI = {
      adult_net_income: 0,
      additional_income: 0,
      childcare_allowance: 0,
      alimony_received: 0,
      childen_net_income: 0,
      family_bonus: 0,
      alimony_paid: 0,
      adults_in_household: 0,
      children_in_household: 0,
      household_income: 0,
      household_income_per_adult: 0
    };
    basicDataFamily.forEach((adult, index) => {
      totalIncome += parseIntoNumber(adult?.net_income_eur);
      incomeData.adult_net_income += parseIntoNumber(adult?.net_income_eur);

      totalIncome += parseIntoNumber(adult?.additional_income_eur);
      incomeData.additional_income += parseIntoNumber(adult?.additional_income_eur);

      totalIncome += parseIntoNumber(adult?.childcare_allowance_eur);
      incomeData.childcare_allowance += parseIntoNumber(adult?.childcare_allowance_eur);

      totalIncome -= parseIntoNumber(adult?.family_bonus_eur);
      incomeData.family_bonus += parseIntoNumber(adult?.family_bonus_eur);

      if (adult.parent_live_separately && index === 0) {
        adult.parent_seprately.forEach(child => {
          if (child.paid) {
            totalIncome -= parseIntoNumber(child?.alimony_amount);
            incomeData.alimony_paid += parseIntoNumber(child?.alimony_amount);
          } else if (child.received) {
            totalIncome += parseIntoNumber(child?.alimony_amount);
            incomeData.alimony_received += parseIntoNumber(child?.alimony_amount);
          }
        });
      } else if (adult.parent_live_separately && index !== 0) {
        if (adult.paid) {
          totalIncome -= parseIntoNumber(adult?.alimony_amount);
          incomeData.alimony_paid += parseIntoNumber(adult?.alimony_amount);
        } else if (adult.received) {
          totalIncome += parseIntoNumber(adult?.alimony_amount);
          incomeData.alimony_received += parseIntoNumber(adult?.alimony_amount);
        }
      }
    });
    basicDataChildren.forEach(child => {
      totalIncome += parseIntoNumber(child?.net_income_eur);
      incomeData.childen_net_income += parseIntoNumber(child?.net_income_eur);
    });
    incomeData.adults_in_household = basicDataFamily.length;
    incomeData.children_in_household = basicDataChildren.filter(
      item => !item.live_separately
    ).length;

    totalHouseholdIncomePerAdult =
      totalIncome /
      (basicDataFamily.length +
        basicDataChildren.filter(item => !item.live_separately).length);

    incomeData.household_income = totalIncome;
    incomeData.household_income_per_adult = totalHouseholdIncomePerAdult;
    return { totalIncome, totalHouseholdIncomePerAdult, ...incomeData };
  };

  const downloadPageasPdf = async () => {
    if (!applicationId) return;
    setIsPdfDownloading(true);
    const calculatedData = calculateTotalIncome();
    const data: HouseholdIncome = {
      additional_income: calculatedData.additional_income,
      adult_net_income: calculatedData.adult_net_income,
      childcare_allowance: calculatedData.childcare_allowance,
      alimony_received: calculatedData.alimony_received,
      adults_in_household: calculatedData.adults_in_household,
      alimony_paid: calculatedData.alimony_paid,
      children_in_household: calculatedData.children_in_household,
      children_net_income: calculatedData.childen_net_income,
      family_bonus: calculatedData.family_bonus,
      household_income: calculatedData.household_income,
      household_income_per_adult: calculatedData.household_income_per_adult,
      household_income_per_application: calculatedData.totalIncome,
      household_income_per_person: calculatedData.totalHouseholdIncomePerAdult,
      submitted_on: submittedOn,
      refund_eur: parseIntoNumber(applicationData?.total_refund_amount),
      refund_percentage: parseIntoNumber(
        applicationData?.total_refund_percentage
      ),
      basic_data_type: basicData as string
    };
    try {
      const response = await dispatch(
        downApplicationPdf(applicationId, data, {
          application_id: applicationId,
          user_id: userProfile.user_id
        })
      );
      if (response.status === 201) {
        console.log(response);
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'antrag.pdf');
        document.body.appendChild(link);
        link.click();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsPdfDownloading(false);
    }
  };

  const takeResponsibility = async () => {
    if (!userProfile.user_id || !applicationId) return;

    try {
      const response = await dispatch(
        applicationPreviewAction.updateResponsiblePerson({
          application_id: parseIntoNumber(applicationId),
          user_id: userProfile.user_id
        })
      );
      if (response.status === 200) {
        successNotification(response.data.message);
        getRegistrationApplicant();
      } else {
        console.log(response);
        errorNotification(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Card>
      <ConditionalRender condition={!isLoading} fallBack={<StandardLoader />}>
        <div>
          <Card.Header>
            <div className="row justify-content-between mb-2 align-items-center flex-column flex-sm-row gap-3 gap-md-0">
              <div className="col-12 col-md-3 d-flex align-items-center gap-3">
                <StandardButton
                  className="px-5"
                  onClick={() => {
                    navigate(APPLICATION);
                  }}
                  buttonText={''}
                  beforeImage={
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      size="2x"
                      className="py-1"
                    />
                  }
                  variant="outline-danger"
                  fullWidth={false}
                />
              </div>
              <div className="col-12 col-md-6">
                <h1 className="text-center fs-40">{t('overview.heading')}</h1>
              </div>
              <div className="col-12 col-md-3 d-flex flex-column flex-md-row gap-3 justify-content-between justify-content-md-end">
                <ConditionalRender
                  condition={
                    false
                  }
                >
                  <ConditionalRender condition={showButtons.responsibility}>
                    <StandardButton
                      buttonText={t('overview.buttons.text_7')}
                      onClick={() => {
                        takeResponsibility();
                      }}
                      variant="success"
                    />
                  </ConditionalRender>
                  <ConditionalRender condition={showButtons.changeStatus}>
                    <Fragment>
                      <StandardButton
                        buttonText={t('overview.buttons.text_4')}
                        onClick={() => {
                          setShowApprovePopup(true);
                        }}
                        variant="success"
                      />
                      <StandardButton
                        fullWidth={false}
                        buttonText={t('overview.buttons.text_5')}
                        onClick={() => {
                          setShowRejectPopup(true);
                        }}
                      />
                      <StandardButton
                        fullWidth={false}
                        buttonText={t('overview.buttons.text_6')}
                        onClick={() => {
                          setShowFeedbackPopup(true);
                        }}
                        variant="warning"
                      />
                    </Fragment>
                  </ConditionalRender>
                </ConditionalRender>
              </div>
            </div>
          </Card.Header>
          <Card.Body id="generate-pdf">
            {/* <div className="mb-4">
              <ApplicationComments comments={comments} />
            </div> */}
            <div className="row">
              <div>
                <StandardButton
                  className={`${
                    isPdfDownloading && 'cursor-not-allowed'
                  } px-2 w-fit`}
                  onClick={() => {
                    downloadPageasPdf();
                  }}
                  buttonText={
                    isPdfDownloading
                      ? t('general.common_text.text_27')
                      : t('general.common_text.text_25')
                  }
                  fullWidth={false}
                  disabled={isPdfDownloading}
                />
              </div>
            </div>
            <ConditionalRender condition={basicData === WITH_INCOME}>
              <div className="row my-2">
                <div className="col-12 col-md-6 my-1">
                  {t('general.text_4')}
                  {'  '}
                  <span className="text-success">
                    {convertToCurrency(calculateTotalIncome().totalIncome)}
                  </span>
                </div>
                <div className="col-12 col-md-6 my-1">
                  {t('general.text_5')}
                  {'  '}
                  <span className="text-success">
                    {convertToCurrency(
                      calculateTotalIncome().totalHouseholdIncomePerAdult
                    )}
                  </span>
                </div>
                <div className="col-12 col-md-6 my-1">
                  {capitalizeFirstLetter(t('application.general.text_18'))}
                  {'  '}
                  <span className="text-success">
                    {applicationData?.total_refund_percentage}%
                  </span>
                </div>
                <div className="col-12 col-md-6 my-1">
                  {t('application.general.text_19')}
                  {'  '}
                  <span className="text-success">
                    {convertToCurrency(
                      applicationData?.total_refund_amount as string
                    )}
                  </span>
                </div>
              </div>
            </ConditionalRender>
            <ConditionalRender condition={applicationType === HEALTH}>
              <HealthApplication
                data={applicationData!}
                basic_data={
                  basicData as typeof WITHOUT_INCOME | typeof WITH_INCOME
                }
                submitted_on={applicationSubmittedDate}
              />
              <HealthApplicationForm
                data={applicationData!}
                basic_data={
                  basicData as typeof WITHOUT_INCOME | typeof WITH_INCOME
                }
              />
            </ConditionalRender>
            <ConditionalRender
              condition={
                applicationType?.toLowerCase() === EDUCATION.toLowerCase()
              }
            >
              <EducationApplication
                data={applicationData!}
                basic_data={
                  basicData as typeof WITHOUT_INCOME | typeof WITH_INCOME
                }
              />
            </ConditionalRender>

            <div className="my-3">
              <hr />
            </div>

            <RegisterApplicant data={userProfileData!} />

            <div className="my-3">
              <hr />
            </div>

            <ConditionalRender
              condition={basicData === WITH_INCOME}
              fallBack={
                <WithoutIncome
                  formDataChildren={basicDataChildren as WithoutIncomeChildI[]}
                  formDataFamily={basicDataFamily as WithoutIncomeFamilyI[]}
                />
              }
            >
              <WithIncome
                formDataChildren={basicDataChildren as WithIncomeChildI[]}
                formDataFamily={basicDataFamily as WithIncomeFamilyI[]}
              />
            </ConditionalRender>
            <ConditionalRender condition={basicData === WITH_INCOME}>
              <WithIncomeCalculator data={calculateTotalIncome()} disable />
            </ConditionalRender>
            <div className="mt-4">
              <h3 className="mb-3">{t('subsidy_calculation_title')}</h3>
              <ConditionalRender
                condition={basicData === WITH_INCOME}
                fallBack={
                  <WithoutIncomeSubsidyCalculation
                    disabled
                    application_type={applicationType as string}
                  />
                }
              >
                <WithIncomeSubsidyCalculation
                  disable
                  application_type={applicationType as string}
                  household_income_per_person={parseIntoNumber(
                    applicationData?.total_house_hold_income_per_person
                  )}
                  net_income={parseIntoNumber(applicationData?.refundable_amount)}
                  refunded_amount={parseIntoNumber(
                    applicationData?.total_refund_amount
                  )}
                />
              </ConditionalRender>
            </div>
          </Card.Body>
          <Card.Footer>
            <div className="row justify-content-center gap-3">
              <StandardButton
                onClick={() => {
                  navigate(APPLICATION);
                }}
                buttonText={t('overview.buttons.text_3')}
                className={
                  'w-auto py-0 d-flex justify-content-center align-items-center px-2'
                }
                variant="outline-danger"
                beforeImage={
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    size="2x"
                    className="py-1"
                  />
                }
              />
              <ConditionalRender condition={false}>
                <ConditionalRender condition={showButtons.responsibility}>
                  <StandardButton
                    buttonText={t('overview.buttons.text_7')}
                    onClick={() => {
                      takeResponsibility();
                    }}
                    variant="success"
                  />
                </ConditionalRender>
                <ConditionalRender condition={showButtons.changeStatus}>
                  <StandardButton
                    onClick={() => {
                      setShowApprovePopup(true);
                    }}
                    buttonText={t('overview.buttons.text_1')}
                    className={'w-auto py-0'}
                    variant="success"
                  />
                  <StandardButton
                    buttonText={t('overview.buttons.text_2')}
                    onClick={() => {
                      setShowRejectPopup(true);
                    }}
                    className={'w-auto py-0'}
                  />
                  <StandardButton
                    buttonText={t('overview.buttons.text_6')}
                    onClick={() => {
                      setShowFeedbackPopup(true);
                    }}
                    variant="warning"
                    className={'w-auto py-0'}
                  />
                </ConditionalRender>
              </ConditionalRender>
            </div>
          </Card.Footer>
        </div>
      </ConditionalRender>
      {renderApproveApplicationModal()}
      {renderRejectApplicationModal()}
      {renderFeedbackApplicationModal()}
    </Card>
  );
};
